import React from "react";
import { useTranslation } from "react-i18next";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { checkLoginStatusMessage } from "@utils/auth";

export default function LoginStatusMessage(props: {
	shouldDisplayStatus: boolean;
}) {
	const { t } = useTranslation("login");

	const { shouldDisplayStatus } = props;

	if (!shouldDisplayStatus) {
		return null;
	}

	const messageDisplayType = checkLoginStatusMessage();

	switch (messageDisplayType) {
		case "isUserLockedOut":
			return (
				<InfoMessageComponent
					type="danger"
					message={t<string>(
						"specific:MEMBERSHIP.LOGIN.ERR_HANDLING.USER_LOCKED"
					)}
					addClassName="u-mar--bottom--sml"
					isMarkdown={true}
				/>
			);
		case "isOasisLockedOut":
			return (
				<InfoMessageComponent
					type="warning"
					message={t<string>("OASIS_GAMING_EXCLUSION")}
					addClassName="u-mar--bottom--sml"
				/>
			);
		case "isSessionExpired":
			return (
				<InfoMessageComponent
					type="warning"
					message={t<string>("SESSION_EXPIRED")}
					addClassName="u-mar--bottom--sml"
				/>
			);

		case "isSessionTerminated":
			return (
				<InfoMessageComponent
					type="warning"
					message={t<string>("SESSION_TERMINATED")}
					addClassName="u-mar--bottom--sml"
				/>
			);
		case "isBlocked":
			return (
				<InfoMessageComponent
					type="danger"
					message={t<string>(
						"error-handling:USER_BLOCKED"
					)}
					addClassName="u-mar--bottom--sml"
				/>
			);
		case "isActivatingAccount":
			return (
				<InfoMessageComponent
					type="warning"
					message={t<string>("ACTIVATING_ACCOUNT_MESSAGE")}
					addClassName="u-mar--bottom--sml"
				/>
			);

		case "isAutomaticLogout":
			return (
				<InfoMessageComponent
					type="warning"
					message={t<string>("AUTOMATIC_LOGOUT_MESSAGE")}
					addClassName="u-mar--bottom--sml"
				/>
			);

		case "isTooManyAttempts":
			return (
				<InfoMessageComponent
					type="danger"
					message={t<string>(
						"error-handling:WRONG_PASS_SESSION_TERMINATED"
					)}
					addClassName="u-mar--bottom--sml"
				/>
			);
		default:
			return null;
	}
}
